<template>
  <generic-modal
    size="large"
    :title="$t('outbox configuration')"
    icon="settings"
    image="/images/icons/outbox.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    :show_ok="false"
    :on_finished="finished"
  >
    <div class="description">
      <providers />
    </div>
  </generic-modal>
</template>

<script>
import { local_api } from "@/utils";
import GenericModal from "@/components/GenericModal";
import Providers from "./Providers";

export default {
  name: "OutboxConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    Providers,
  },
  computed: {},
  data() {
    return {
      configuration: {},
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(vm, "post", "/outbox/do-save-configuration", {
          s: vm.configuration,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {
    // let vm = this;
    // vm.init();
  },
  watch: {},
  updated: function() {},
};
</script>
